import { useState} from "react";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import PersonIcon from '@mui/icons-material/Person';
import { blue } from '@mui/material/colors';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch} from 'react-redux';

import { closeDialog } from 'store/main/userSettingsDialog';
import DialogContent from '@mui/material/DialogContent';
import { Button } from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { UserProjects } from './UserProjects';
import UserProjectsSelected from "./UserProjectsSelected";
import { trackEvent } from "./Tracking";

type TUser = {
    email:string,
    id : string
}

const UserSettings = (props:TUser) => {
    const dispatch = useDispatch();
	
    const {email, id} = props
    const [addAcccessLevel, setAddAcccessLevel] = useState('');
    const [projectSelected, setProjectSelected] = useState('')
    const [showAddProject, setShowAddProject] = useState(false)

    const handleAddProject = () => {
        setAddAcccessLevel('')
        setProjectSelected('')
        setShowAddProject(true)
    }
    
    return (
        <Dialog
            fullWidth
            sx={{
                '& .MuiPaper-root': {
                backgroundColor: 'transparent', // Custom background color
                },
                '& .MuiDialog-paper': {
                    backgroundColor: '#fff !important',  // Change to your desired color
                },
            }}
            open={true}
            onClose={() => dispatch(closeDialog())}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            >
            <DialogTitle id="alert-dialog-title">User settings</DialogTitle>
            <ListItemButton>
                <ListItemAvatar>
                    <Avatar sx={{ bgcolor: blue[100], color: blue[600] }}>
                    <PersonIcon />
                    </Avatar>
                </ListItemAvatar>
                <ListItemText primary={email} />
            </ListItemButton>
            <IconButton
                aria-label="close"
                onClick={() => dispatch(closeDialog())}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
                >
                <CloseIcon />
            </IconButton>
            <DialogContent>
           
            {
            !showAddProject ?
           
                <div style={{ display:'flex', alignContent:'center', justifyContent:'flex-end'}}>
                    <Button 
                        onClick={() => {
                            trackEvent("UserProfile", "My Team", "Add User Project");
                            handleAddProject();
                        }} 
                        style={{backgroundColor: '#fff', color:'#000'}} 
                        variant="contained" 
                        startIcon={<PersonAddIcon fontSize="small"/>} 
                    >
                        Add project
                    </Button>
                </div>
                
                :
                ''
            }
            {
            showAddProject ?
                <>
                <UserProjects id={id} email={email}/>
                </>
            :
            ''
            }
            <UserProjectsSelected id={id} email={email}/>
            </DialogContent>
        </Dialog>   
    );
};

export default UserSettings;
